import { useQuery } from '@apollo/client'
import { cache } from '@lib/graphql/cache'
import {
  ALL_ACCOUNTS,
  GET_USER_ACCOUNT
} from '@lib/graphql/havelock/queries/organization'
import {
  ALL_OPERATORS,
  ALL_PRODUCTION_UNITS
} from '@lib/graphql/prodactive/queries/organization'
import { GraphqlApi } from '@mono/packages/graphql/apollo/constants'
import { isPresignedUrlExpiring } from '@mono/packages/utils/attachments'
import { useEffect } from 'react'
import useUser from './useUser'

const havelockGraphqlContext = {
  api: GraphqlApi.Havelock
}

const useSharedData = () => {
  const { account } = useUser()
  const skipSharedQueries = account.prodactiveEnabled !== true

  const { refetch: refetchAllAccounts } = useQuery(ALL_ACCOUNTS, {
    fetchPolicy: 'network-only',
    pollInterval: 1000 * 60 * 60 * 2,
    context: havelockGraphqlContext,
    skip: skipSharedQueries
  })

  useQuery(ALL_OPERATORS, {
    fetchPolicy: 'network-only',
    pollInterval: 1000 * 60 * 60 * 2,
    skip: skipSharedQueries
  })

  useQuery(ALL_PRODUCTION_UNITS, {
    fetchPolicy: 'network-only',
    pollInterval: 1000 * 60 * 60 * 2,
    skip: skipSharedQueries
  })

  useEffect(() => {
    if (typeof document === 'undefined' || skipSharedQueries) return

    const handleVisibilityChange = () => {
      if (document.visibilityState !== 'visible') return

      const query = cache.readQuery({
        query: GET_USER_ACCOUNT
      })

      const profileImage = query?.getCurrentUserAccount?.profileImage
      const sampleUrl = profileImage?.thumbnailUrl ?? profileImage?.presignedUrl

      if (isPresignedUrlExpiring(sampleUrl)) {
        refetchAllAccounts()
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [refetchAllAccounts, skipSharedQueries])
}

export default useSharedData
